exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sweet-loading{text-align:center;position:fixed;top:calc((100vh - 50px)/2);left:calc((100vw - 50px)/2);z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/SweetLoading.scss
// module id = 670
// module chunks = 0